'use client'

import { Button, TextInput } from '@carbon/react'
import { Email } from '@carbon/react/icons'
import { useState } from 'react'
import { useEffect } from 'react'
import { normalizeLocale } from '@kmerhosting/i18n'
import { publicPagesCopy } from '@/lib/public-pages-i18n'

const validEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) && value.length <= 254

export function NewsletterSignup() {
  const [locale, setLocale] = useState(() => normalizeLocale(typeof document === 'undefined' ? 'en' : document.documentElement.lang) || 'en')
  const [invalid, setInvalid] = useState(false)
  const [message, setMessage] = useState('')
  useEffect(() => {
    const update = (event: Event) => setLocale(normalizeLocale(event instanceof CustomEvent ? String(event.detail) : document.documentElement.lang) || 'en')
    window.addEventListener('kmerhosting:language-change', update)
    return () => window.removeEventListener('kmerhosting:language-change', update)
  }, [])
  const copy = publicPagesCopy(locale)

  const submit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const data = new FormData(event.currentTarget)
    const email = String(data.get('email') || '').trim().toLowerCase()
    if (!validEmail(email)) {
      setInvalid(true)
      setMessage(copy.invalidEmail)
      return
    }

    setInvalid(false)
    setMessage('')
    window.open(`https://dash.kmerhosting.com/newsletter/#email=${encodeURIComponent(email)}`, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className="site-footer__newsletter">
      <p className="site-footer__newsletter-title">{copy.newsletter}</p>
      <p className="site-footer__newsletter-copy">{copy.newsletterIntro}</p>
      <form className="site-footer__newsletter-form" onSubmit={submit} noValidate>
        <TextInput
          id="footer-newsletter-email"
          name="email"
          labelText={copy.emailAddress}
          type="email"
          autoComplete="email"
          invalid={invalid}
          invalidText={message}
          size="sm"
          required
        />
        <Button type="submit" size="sm" renderIcon={Email}>{copy.subscribe}</Button>
      </form>
    </div>
  )
}
